import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { API_SERVER_ADDRESS } from '../../environments/environment';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class BuscadorService {

  constructor(private http: HttpClient) { }

  // Gestión de Paradas
  getOriginStops(): Observable<any> {
    return this.http.get(`${API_SERVER_ADDRESS}/v1/paradas`).pipe(
      map(results => results['paradas'])
    );
  }

  getDestinationStopsByOrigin(originId): Observable<any> {
    originId = typeof originId !== 'undefined' ? originId : 0;
    return this.http.get(`${API_SERVER_ADDRESS}/v1/paradas/${originId}/por-origen`).pipe(
      map(results => results['paradas'])
    );
  }

  getOriginStopsByDestination(destinationId): Observable<any> {
    destinationId = typeof destinationId !== 'undefined' ? destinationId : 0;
    return this.http.get(`${API_SERVER_ADDRESS}/v1/paradas/${destinationId}/por-destino`).pipe(
      map(results => results['paradas'])
    );
  }

  // Búsqueda de Expediciones
  searchExpeditions(originId, destinationId, date): Observable<any> {
    return this.http.get(`${API_SERVER_ADDRESS}/v1/buscador/${originId}/${destinationId}/${date}`).pipe(
      map(results => results)
    );
  }

  // Detalles y Tracking
  getExpeditionDetails(expeditionId, options: any = {}): Observable<any> {
    let url = `${API_SERVER_ADDRESS}/v1/expediciones/${expeditionId}`;
    if (options.associated) {
      url += `?associated=${options.associated}`;
    }
    return this.http.get(url).pipe(
      map(results => results)
    );
  }


  // Expediciones por Parada
  getExpeditionsByStopToday(stopId): Observable<any> {
    return this.http.get(`${API_SERVER_ADDRESS}/v1/paradas/${stopId}/expediciones-hoy`).pipe(
      map(results => results)
    );
  }

  getExpeditionRouteFromStop(expeditionId, stopId): Observable<any> {
    return this.http.get(`${API_SERVER_ADDRESS}/v1/expediciones/${expeditionId}/recorrido-desde/${stopId}`).pipe(
      map(results => results['expedicion'])
    );
  }
}